/** @format */

import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSession } from "../../context/useSession";

export function Autenticacao() {
  const { search } = useLocation();
  const history = useHistory();
  const { getSession, session } = useSession();

  useEffect(() => {
    if (window.location.pathname === "/autenticacao") {
      window.localStorage.setItem("params", search);
      getSession(search);
    }
    if (session.idvarejista) {
      if (session?.redirect !== "" && session?.redirect !== undefined) {
        history.push("/");
        setTimeout(() => {
          history.push(session?.redirect);
        }, 100);
      } else {
        history.push("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  return <div />;
}
